<template>
	<div>
		<k-tabs grow v-model="clip_filter" v-if="read_only != true">
			<k-tab name="own" label="My clips"></k-tab>
			<k-tab name="all" label="All clips"></k-tab>
			<k-tab name="exports" label="Exports"></k-tab>
			<k-tab name="tags" label="Tags"></k-tab>
		</k-tabs>

		<div v-if="clip_filter == 'tags'">
			<tag-list :event_uuid="uuid" v-if="uuid" @selected="tag_selected"></tag-list>
		</div>

		<div v-if="clip_filter == 'exports'">
			<export-list :event_uuid="uuid" v-if="uuid"></export-list>
		</div>

		<k-data-table v-if="clip_filter != 'tags' && clip_filter != 'exports'" style=""
			:items="filtered_clips"
			hide-actions
			:headers="headers">

			<template slot="items" slot-scope="props">
				<tr>
				<td @click="open_edit(props.item)">
					<k-progress-circular v-if="get_status(props.item) == 'processing'" indeterminate :size="20" :width="2" color="deep-orange"></k-progress-circular>
					<k-icon v-if="get_status(props.item) == 'ready'" color="deep-orange">done</k-icon>
					<k-icon v-if="get_status(props.item) == 'error'" color="deep-orange">error</k-icon>
				</td>
				<td @click="open_edit(props.item)">{{props.item[0].meta.title}}</td>
				<td @click="open_edit(props.item)">{{props.item[0].meta.clip_type}}</td>
				<td @click="open_edit(props.item)">{{props.item[0].date}}</td>
				<td @click="open_edit(props.item)">{{format_time(props.item[0].start_time)}}</td>
				<td @click="open_edit(props.item)">{{format_time(props.item[0].end_time)}}</td>
				<td @click="open_edit(props.item)">{{format_time(props.item[0].end_time - props.item[0].start_time)}}</td>
				<td @click="open_edit(props.item)">{{props.item[0].meta.account}}</td>
				<td class="text-xs-right" style="white-space: nowrap;">
				<div style="display: inline-flex; flex-wrap: nowrap; align-items: center; justify-content: flex-end;">

					<k-menu bottom left :disabled="is_not_ready(props.item)">
						<k-btn slot="activator" size="s" icon icon-name="play_circle_outline" :disabled="is_not_ready(props.item)"></k-btn>
						<k-list :items="props.item" @click="open_clip_open">
							<template #default="{item: quality}">
								{{ get_quality_title(quality, "Play") }}
							</template>
							<template #subtitle="{item: quality}">
								{{ get_quality_subtitle(quality, "") }}
							</template>
							<template #right="{item: quality}">
								<k-progress-circular v-if="quality.status == 'processing'" indeterminate :size="20" :width="2" color="deep-orange"></k-progress-circular>
								<k-icon small v-if="quality.status == 'ready'">play_circle_outline</k-icon>
								<k-icon small v-if="quality.status == 'error'">error</k-icon>
							</template>
						</k-list>
					</k-menu>


					<k-menu bottom left :disabled="is_not_ready(props.item)">
						<k-btn slot="activator" size="s" icon icon-name="file_download" :disabled="is_not_ready(props.item)" download></k-btn>
						<k-list :items="props.item" @click="open_clip_download">
							<template #default="{item: quality}">
								{{ get_quality_title(quality, "Play") }}
							</template>
							<template #subtitle="{item: quality}">
								{{ get_quality_subtitle(quality, "") }}
							</template>
							<template #right="{item: quality}">
								<k-progress-circular v-if="quality.status == 'processing'" indeterminate :size="20" :width="2" color="deep-orange"></k-progress-circular>
								<k-icon small v-if="quality.status == 'ready'">play_circle_outline</k-icon>
								<k-icon small v-if="quality.status == 'error'">error</k-icon>
							</template>
						</k-list>
					</k-menu>

					<k-btn @click="regenerate(props.item)" size="s" icon icon-name="refresh"></k-btn>

					<k-menu bottom left v-if="export_forms.length > 0" :disabled="get_status(props.item) != 'ready' || !is_valid_exports_found(export_forms, props.item)">
						<k-btn slot="activator" size="s" icon icon-name="cloud_upload" :disabled="get_status(props.item) != 'ready' || !is_valid_exports_found(export_forms, props.item)">
						</k-btn>
						<k-list :items="export_forms" @click="(item) => { open_export_dialog(props.item, item.id)}" class="small" v-if="export_forms.length > 0">
							<template #default="{item: conf}">
								{{conf.title || conf.name}}
							</template>
							<template #right="{item: conf}">
								<k-icon>cloud_upload</k-icon>
							</template>
						</k-list>
					</k-menu>

				</div>
				</td>
			</tr>
			</template>
		</k-data-table>


		<k-dialog width="350" v-model="edit_dialog.active">
			<k-panel class="ks-floating-menu">
				<template #default>
					<clip-editor :event-uuid="uuid" :uuid="edit_dialog.uuid" v-if="edit_dialog.active" v-on:save="edit_dialog.active = false" @close="edit_dialog.active=false"></clip-editor>
				</template>
			</k-panel>
		</k-dialog>

		<k-dialog width="800" v-model="export_dialog.active">
			<k-panel class="ks-floating-menu">
				<template #default>
					<export-editor v-model="export_dialog.active" :event_uuid="uuid" :qualities="export_dialog.qualities" :settings_id="export_dialog.settings" v-if="export_dialog.active"></export-editor>
				</template>
			</k-panel>
		</k-dialog>
	</div>
</template>


<script>
import moment from 'moment'
import ClipEditor from './Clip.vue';
import ExportEditor from './Export.vue';
import SettingsModel from '@/models/settings.js'
import ClipModel from '@/models/clip.js'
import Vue from 'vue';
import { mapMutations } from 'vuex'

import TagList from '../events/tags/List.vue';
import ExportList from './ExportList.vue'

export default {
	props: ["uuid"],
	components: {
		ClipEditor,
		ExportEditor,
		TagList,
		ExportList
	},
	data () {
		var clips_ch = this.$cloudserver.channel("events:clips:"+this.uuid);
		return {
			ws_channel: clips_ch,
			clips: [],
			clip_filter: "own",
			save_dialog: false,
			export_dialog: {
				active: false,
				qualities: [],
				settings: {}
			},
			edit_dialog: {
				active: false,
				uuid: undefined
			},
			headers: [
				{text: "", sortable: false, width: 20},
				{text: "Title", sortable: false},
				{text: "Type", sortable: false},
				{text: "Created", sortable: false,},
				{text: "Start time", sortable: false},
				{text: "End Time", sortable: false},
				{text: "Duration", sortable: false,},
				{text: "Creator", sortable: false},
				{text: "Actions", sortable: false, align: "right", width: 300}
			],
			to_be_loaded: []
		}
	},
	created() {
		window.addEventListener('keydown', this.keyDown);
		this.ws_channel.join();
	},
	watch: {
		"ws_channel.data": {
			handler(newVal, oldVal) {
				var self = this;
				if (typeof(newVal.clips) != "undefined") {
					_.each(newVal.clips, (clip) => {
						Vue.set(self.clips, clip.uuid, clip);
					});
				}
				if (typeof(newVal.clip) != "undefined") {
					var clip = newVal.clip;
					Vue.set(self.clips, clip.uuid, clip);

					if ( clip.status == "ready" && this.to_be_loaded.includes( clip.uuid ) ) {
						this.open_clip(clip, true)
						this.to_be_loaded = this.to_be_loaded.filter( _ => { return _ != clip.uuid } )
					}
				}
			},
			deep: true
		},
		"export_dialog.active" (val) {
			if(!val) {
				this.export_dialog.qualities = [];
				this.export_dialog.settings = {};
				this.$emit("disable-key-events", false);
			} else {
				this.$emit("disable-key-events", true);
			}
		}
	},
	methods: {
		open_edit(clip_list) {
			var clip = clip_list[0]
			this.edit_dialog.uuid = clip.uuid;
			this.edit_dialog.active = true;
		},
		keyDown(event) {
 			if (event.keyCode == 88 && event.altKey) {
				 // X
				 this.get_latest_own_clip()
 			}
		},
		tag_selected(tag) {
			this.$emit("position", tag.stream_time);
		},
		get_latest_own_clip() {
			this.clip_filter = 'own'
			let own_clips = [...this.filtered_clips]
			if(!own_clips) return
			if(!own_clips[0]) return
			if(own_clips[0][0].status != 'ready') {
				this.to_be_loaded.push(own_clips[0][0].uuid)
			} else this.open_clip(own_clips[0][0], true)
		},
		format_time (time, paddedHours) {
			if(time < 0) return "-";
		  time = time * 1000
  		time = parseInt(time/1000)
  		const seconds = time % 60
  		time = parseInt(time/60)
  		const minutes = time % 60
  		time = parseInt(time/60)
  		const hours = time % 24
  		const days = parseInt(time/24)
  		let out = ''
  		if (days && days > 0) {
    		out += days + ':'
    		if (hours < 1) out += '00:'
  		}
  		if (hours && hours > 0 || paddedHours) out += ('0' + hours).slice(-2) + ':'
  		out += ('0' + minutes).slice(-2) + ':'
  		out += ('0' + seconds).slice(-2)
  		return out.trim()
		},
		is_not_ready(qualities) {
			var res = _.find(qualities, {status: "ready"});
			return _.isEmpty(res);
		},
		get_status(qualities) {
			var status_list = ["new", "processing", "error", "ready"];
			return _.minBy(qualities, (quality) => { return status_list.indexOf(quality.status); }).status;
		},
		get_quality_title(clip, default_text) {
			return ClipModel.get_title(clip, default_text)
		},
		get_quality_subtitle(clip, default_text) {
			return ClipModel.get_subtitle(clip, default_text)
		},
		get_quality_name(clip) {
			return ClipModel.get_name(clip);
		},
		regenerate(qualities) {
			var uuids = _.map(qualities, (quality) => {
				this.ws_channel.push("regenerate_clip", {uuid: quality.uuid});
				return quality.uuid;
			});
			this.add_process({type: "cloudrec", event: "re-create-clip", description: "Re-create clip "+qualities[0].meta.title, meta: {uuids: uuids, event_uuid: this.uuid}});
		},
		is_valid_export(qualities, settings) {
			var required_qualities = _.get(settings, "value.form.required_qualities", []);
			var quality_names = _.map(qualities, q => this.get_quality_name(q));
			return required_qualities.every(q=> quality_names.indexOf(q) !== -1);
		},
		is_valid_exports_found(settings_list, qualities) {
			return settings_list.some((settings) => {
				return this.is_valid_export(qualities, settings);
			});
		},
		open_export_dialog(qualities, settings) {
			console.log(qualities, settings);
			this.export_dialog.qualities = qualities;
			this.export_dialog.settings = settings;
			this.export_dialog.active = true;
		},
		open_clip_open(clip) {
				this.open_clip(clip, false);
		},
		open_clip_download(clip) {
				this.open_clip(clip, true);
		},
		open_clip(clip, download) {
			ClipModel.open(clip, download).catch(() => {
				this.$message.warning("Clip "+clip.meta.title+" not found!\nRe-creating clip...");
				this.ws_channel.push("regenerate_clip", {uuid: clip.uuid});
				this.add_process({type: "cloudrec", event: "re-create-clip", description: "Re-create clip "+clip.meta.title, meta: {uuids: [clip.uuid], event_uuid: this.uuid}});
			})
		},
		...mapMutations({add_process: 'processes/add'})
	},
	computed: {
		filtered_clips () {
			var clips = Object.values(this.clips);
			clips = _.filter(clips, (clip) => {
				if (this.clip_filter == "all") {
					return true;
				}
				if (this.clip_filter == "own") {
					if (clip.meta.account == this.account.email) return true;
				}
				if (this.clip_filter == "highlights") {
					if (clip.meta.highlight == true) return true;
				}
			});
			clips = _.map(clips, (clip) => {
				var m = moment.utc(clip.inserted_at);
				clip["timestamp"] = m.unix();
				clip["date"] = m.local().format("L LTS");
				return clip;
			})
			clips = _.groupBy(clips, (clip) => {
				return clip.meta.group_uuid || clip.uuid+"-"+clip.timestamp;
			});
			clips = _.map(clips, (clip) => {
				return _.orderBy(clip, (c) => { return _.get(c, ["meta", "quality", "order_num"], 0); }, ["asc"]);
			});
			return _.orderBy(clips, (clip_list) => { return clip_list[0].timestamp; }, ["desc"]);
		},
		read_only() {
			if (typeof(this.account) == "undefined") return true;
			if (typeof(this.account.meta) == "undefined") return true;
			if (this.account.meta.rec_readonly === true) {
				this.clip_filter = "all";
				return true;
			}
		},
		account () {
			return this.$store.state.account;
		},
		export_forms () {
      let forms = _.filter(
        SettingsModel.list("export_form"),
        (form) => { return _.get(form, "value.hide", false) == false; }
      )

      return _.orderBy(
        forms,
        (form) => { return form.title || form.name; },
        ["asc"]
      )
		}
	},
	destroyed() {
		window.removeEventListener('keydown', this.keyDown);
	}
}
</script>

<style>
.small .v-list__tile {
	border-bottom: 1px solid #eee;
}
.small:last-child .v-list__tile {
	border-bottom: none;
}
</style>
